import App from './App.svelte'
import { strings } from '../store/store'

let target = document.querySelector('#emission-calculator')

strings.set({
  ...target.dataset,
  defaultDieselPrice: Number(
    target.dataset.defaultDieselPrice.replace(',', '.')
  ),
})

const app = new App({
  target,
})

export default app
